import type { ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"
import {
  formatDurationSince,
  getProviderName,
} from "@/v2-backoffice-client/uptime/uptime.utils"
import type { UptimeInlineFragment } from "@/v2-backoffice-client/uptime/inline/__types__/uptime.inline.fragment"

export type UptimeDashboardDownRowProps = ComponentProps<"div"> & {
  target: UptimeInlineFragment
}

// One row in the "Down" lane of the wall-display dashboard. Pairs
// the failure reason (HTTP status + last error) with a 30-day
// history strip so the room can tell "first time today" apart from
// "flapping for a week" without leaving the dashboard.
function UptimeDashboardDownRow(props: UptimeDashboardDownRowProps) {
  const { target, className, ...divProps } = props

  const reason =
    target.LastErrorHttpStatus != null
      ? `HTTP ${target.LastErrorHttpStatus} · ${target.LastError ?? ""}`
      : (target.LastError ?? "no error message captured")
  const provider = getProviderName(target)

  return (
    <div className={cn("uptime-dashboard-row", className)} {...divProps}>
      <div className="uptime-dashboard-row-main">
        <div className="uptime-dashboard-row-name">
          {target.Name ?? target.Identifier}
        </div>
        <div className="uptime-dashboard-row-reason" title={reason}>
          {reason}
        </div>
        <div className="uptime-dashboard-row-meta">
          <span className="uptime-dashboard-row-provider">{provider}</span>
          <span className="uptime-dashboard-row-aside">
            down for {formatDurationSince(target.CurrentStatusSince)}
          </span>
        </div>
      </div>
    </div>
  )
}

export default UptimeDashboardDownRow
